/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Unlinkfailed1Inputs */

const zh_linked_unlinkfailed1 = /** @type {(inputs: Linked_Unlinkfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解除绑定失败`)
};

const en_linked_unlinkfailed1 = /** @type {(inputs: Linked_Unlinkfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unlink account`)
};

const es_linked_unlinkfailed1 = /** @type {(inputs: Linked_Unlinkfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al desvincular`)
};

/**
* | output |
* | --- |
* | "Failed to unlink account" |
*
* @param {Linked_Unlinkfailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const linked_unlinkfailed1 = /** @type {((inputs?: Linked_Unlinkfailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Unlinkfailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_unlinkfailed1(inputs)
	if (locale === "en") return en_linked_unlinkfailed1(inputs)
	return es_linked_unlinkfailed1(inputs)
});
export { linked_unlinkfailed1 as "linked_unlinkFailed" }